// dependencies
import React from "react";

// components
import ComponentLoader from "../../../../components/Spinner/ComponentLoader";

// store
import { useSurveysPageTab } from "./store/store";

// hooks
import { useRbacPrimaryRolePermissions } from "../../../../api/hooks";
import { useFeatureFlagQuery } from "../../../../hooks/useFeatureFlag";

// pages
import ErrorPage from "../../../Error";
import ListSurveys from "./tabs/ListSurveys";

const Surveys = () => {
	const surveysPageTab = useSurveysPageTab();

	const {
		value: ffSurveys,
		query: { isLoading: isLoadingFFSurveys },
	} = useFeatureFlagQuery("ff-is-surveys-enabled", false);
	const { data: rbacPermissions, isLoading: isLoadingRbacPermissions } = useRbacPrimaryRolePermissions("surveys");

	if (!ffSurveys && !isLoadingFFSurveys) {
		return <ErrorPage code={403} />;
	}

	if (!rbacPermissions?.includes("surveys:viewSurveys") && !isLoadingRbacPermissions) {
		return <ErrorPage code={403} />;
	}

	if (isLoadingFFSurveys || isLoadingRbacPermissions) {
		return <ComponentLoader />;
	}

	return (
		<div className="border-t-[1px] border-solid border-neutral-2">
			{surveysPageTab.key === "all-surveys" && <ListSurveys />}
		</div>
	);
};

export default Surveys;
